<style scoped>
.card.main-front, .card.main-back  {
    background: #e0e1ea;
}
.card.card.main-back {
    height: 38rem;
}
.card.card-photo {
    height: 18.438rem;
    width: 13.875rem;
    border: 1px solid #676767;
    border-radius: 15px;
}
.card.card-photo2 {
    height: 9.4rem;
    width: 7.5rem;
    border: 1px solid #676767;
    border-radius: 6px;
}
.card.card-code-qr {
    height: 10.438rem;
    width: 10.438rem;
    border: 1px solid #676767;
    border-radius: 15px;
}
.card.card-code-qr2 {
    height: 5rem !important;
    width: 5rem !important;
    border: 1px solid #676767;
    border-radius: 5px;
}
h3 .kap {
    color: #2d396f;
}
.text-brown {
    color: #633317;
}
.title {
    font-size: 2.5rem;
    font-weight: bold;
}
.text-brown.title {
    font-weight: revert;
    font-size: 2.5rem;
}
.text-brown.title2 {
    font-weight: 800 !important;
    font-size: 1.5rem;
}

#card-qrcode>img {
    width: 100% !important;
    height: 100% !important;
}
/* Flip Cards CSS */
.card-container {
  display: grid;
  perspective: 700px;
}

.card.front {
    background-image: url("/img/bg-front-biasa.svg");
    background-size: cover;
    background-position: bottom;
}

.card.front-print {
    background: url("/img/bg-front-biasa-print.png");
    background-size: cover;
}

.card.back {
    background-image: url("/img/bg-back-biasa.svg");
    background-size: cover;
    background-position: bottom;
}
.card.back2-print {
    background-image: url("/img/bg-back-biasa-print.png");
    background-size: cover;
}

.card-flip {
  display: grid;
  grid-template: 1fr / 1fr;
  grid-template-areas: "frontAndBack";
  transform-style: preserve-3d;
  transition: all 0.7s ease;
}
.card-flip .card .card-body {
    cursor: pointer;
}

.card-flip div {
  backface-visibility: hidden;
  transform-style: preserve-3d;
}

.front, .front-print {
  grid-area: frontAndBack;
}

.back {
  grid-area: frontAndBack;
  transform: rotateY(-180deg);
}
.back2 {
  grid-area: frontAndBack;
}

input[type='checkbox']:checked + .card-container .card-flip {
  transform: rotateY(180deg);
}
.cardser {
  margin: 10px 10px;
}

input[type='checkbox'] {
  display: none;
}

ol.list-terms li {
    font-size: 16px;
}
ol.list-terms2 li {
    font-size: 0.58rem !important;
    font-weight: bold;
}

.title-iapi {
    color: white;
    background: linear-gradient(to right, #3CC0EE 0.03%, #24316D 99.96%);
    padding: 10px 60px 10px 60px;
    border-radius: 40px 0px;
}
.title-iapi2 {
    color: white;
    background: linear-gradient(to right, #3CC0EE 0.03%, #24316D 99.96%);
    padding: 4px 32px 4px 32px;
    border-radius: 40px 0px;
    
    font-weight: 700;
    font-size: 0.75rem;
    line-height: 126.19%;
}
.column-pdf p {
    font-size: 0.73rem;
}
.vue-html2-pdf .card.card-code-qr2 .card-body {
    padding: 0.2rem !important;
}
.card.card-photo img, .card.card-photo2 img {
    border-radius: 2px;
    object-fit: cover;
}
.terms .bg-terms:nth-child(odd) {
    background: #D8D9DC;
}
.terms .bg-terms:nth-child(even) {
    background:#E9EAF0;
}
@media print {
    @page {
      size: 8.6cm 5.4cm !important;
      margin: 0 !important;
    }
}
</style>
 
<template>
<div>
    <div class="row mb-4 d-flex justify-content-between align-items-end mx-auto">
        <button class="btn btn btn-info px-3 mr-2" @click="exportImage()">Export</button>
        <button class="btn btn btn-dark" @click="$router.go(-1)">Kembali</button>
    </div>
    <input type="checkbox" id="card-1"/>
            
    <vue-html2pdf
        :show-layout="true"
        :float-layout="false"
        :enable-download="false" 
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        :filename="'KARTU-ANGGOTA-' + this.items.noAnggota ? this.items.noAnggota : 'BIASA'"
        :pdf-quality="2"
        :manual-pagination="true"
        :margin="0"
        pdf-format="cr80"
        pdf-orientation="landscape"
        pdf-content-width=""
        @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
    >
        <section slot="pdf-content">
            <div class="row">
                <div class="col-md-6">
                    <!-- Card 1 Front -->
                    <section class="pdf-item">
                        <div class="card front-print mx-auto border-0" style="width: 506px; height: 319px;" ref="printFront">
                            <div class="card-body px-3 py-2">
                                <div class="row">
                                <div class="col-12 d-flex justify-content-between align-items-center">
                                        <img src="/img/logo-iapi-transparent.gif" alt="" width="42%">
                                        <img src="/img/ifac.png" alt="" width="22%" >
                                        <img src="/img/logo_cpa.png" alt="" width="22%">
                                    </div>
                                </div>
                                <div class="row mt-2 pl-3 ml-2">
                                    <h1 class="text-uppercase mx-auto text-brown text-white title2 pl-5 mt-2">Kartu Anggota IAPI</h1>
                                </div>
                                <div class="row justify-content-between align-items-center" style="margin-top: 0.55rem">
                                    <div class="col-3">
                                        <div class="card card-photo2 mb-0">
                                            <div class="card-body justify-content-center row py-1">
                                                <img :src="lihat_foto  ? lihat_foto : '/img/placeholder-image.png'" alt="" @error="imgError" class="img img-responsive" width="100%" height="100%" >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9">
                                        <div class="row justify-content-between pl-4 align-items-center">
                                            <div class="col-7 pl-4">
                                                <div class="row flex-column column-pdf">
                                                    <div>
                                                        <p style="font-size: 0.85rem; font-weight: bold !important;" class="h4 text-white font-weight-bold mb-1">{{ items.namaLengkap ? items.namaLengkap : '-'}}</p>
                                                        <p class="h4 text-white font-weight-bold text-uppercase">{{ items.namaKategori ? items.namaKategori : '-'}}</p>
                                                        <p style="font-size: 0.8rem;" class="h4 text-white font-weight-bold kap">KAP {{ items.namaKap ? items.namaKap : '-'}}</p>
                                                    </div>
                                                    <div class="mt-2">
                                                        <p style="font-size: 0.688rem;" class="h5 font-weight-bold text-white mb-1">No.Reg.IAPI {{ items.noAnggota ? items.noAnggota : '-'}}</p>
                                                        <!-- <p style="font-size: 0.688rem;" class="h5 font-weight-bold text-white mb-1">No.Reg.IAPI {{ items.noAnggota ? items.noAnggota : '-'}}  / CPA No. K-000237</p> -->
                                                        <p style="font-size: 0.688rem;" class="h5 font-weight-bold text-white mb-0">No.Reg.Izin {{ items.noIzinAp ? items.noIzinAp: '-'}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-4 pl-2">
                                                <div class="card card-code-qr2">
                                                    <div class="card-body p-2" id="card-qrcode2"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row mt-2">
                                <div class="col-12 d-flex justify-content-between px-0">
                                    <div class="col-2 px-0 text-center">
                                            <p style="color: #57585C; font-size: 0.5rem; font-weight: bold; letter-spacing: 0.01em; line-height: 0.586rem;">Kartu Anggota <br> berlaku untuk <br> 1 tahun</p>
                                    </div>
                                    <div class="col-2 px-0 text-center ml-3">
                                            <p style="color: #57585C; font-size: 0.5rem; font-weight: bold; letter-spacing: 0.04em; line-height: 0.586rem;">Izin Akuntan Publik <br> berlaku untuk <br> 5 tahun</p>
                                    </div>
                                    <div class="col-4 pr-0 px-0 text-center">
                                            <p style="color: #57585C; font-size: 0.5rem; font-weight: bold; letter-spacing: 0.04em; line-height: 0.586rem;">Masa berlaku kartu anggota dan <br> izin akuntan publik <br> silahkan scan pada QR code</p>
                                    </div>
                                    <div class="col-4 text-center mr-5 pl-0">
                                            <p style="color: #57585C; font-size: 0.45rem; font-weight: bold; letter-spacing: 0.04em; line-height: 105.5%;">Apabila terdapat <br> perbedaan informasi pada kartu <br> anggota dengan QR Code, maka <br> data yang benar adalah data <br> pada QR Code</p>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <!-- End Card 1 Front -->
                </div>
                <div class="col-md-6">
                    <!-- Card 1 Back -->
                    <section class="pdf-item">
                        <div class="card back2-print mx-auto border-0" style="width: 506px; height: 319px;" ref="printBack">
                            <div class="card-body d-flex justify-content-between flex-column px-0">
                                <div class="row pl-2">
                                    <div class="col-12 text-white pr-5 pt-2">
                                        <ol class="list-terms2">
                                            <li>Kartu ini milik Institut Akuntan Publik Indonesia (IAPI).</li>
                                            <li>Pemegang kartu ini adalah Anggota Biasa yang memiliki izin praktik yang masih berlaku.</li>
                                            <li>Kartu ini tidak berlaku apabila Anggota Biasa tersebut tidak aktif karena mengundurkan <br> diri atau dikenakan Sanksi Pemberhentian sebagai Anggota.</li>
                                            <li>Kartu ini tidak dapat dipindahtangankan.</li>
                                            <li>Apabila menemukan kartu ini, mohon dikembalikan kepada nama yang tertera di kartu <br> atau ke alamat dibawah ini.</li>
                                        </ol> 
                                    </div>
                                </div>
                                    <center class="mt-4">
                                        <div class="row">
                                            <div class="mx-auto text-center">
                                                <!-- <img src="/img/ttd-new.png" alt="" style="width: 5rem" class="mb-n1"> -->
						<br/><br/>
                                                <h6 style="font-size: .5rem; color: #232031;" class="mb-0 font-weight-bold">Tarkosunaryo, MBA, CPA</h6>
                                                <h6 style="font-size: .5rem; color: #232031;" class="mb-1 font-weight-bold">Ketua Umum</h6>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <h3 class="text-uppercase mx-auto title-iapi2 mb-1">INSTITUT AKUNTAN PUBLIK INDONESIA</h3>
                                        </div>
                                        <div>
                                            <p style="font-size: 0.6rem; line-height: 134.69%; letter-spacing: -0.01em; font-weight: bold;" class="mb-0">
                                                Office 8 Building 12th Floor, Unit 12I – 12J, Sudirman Central Business District (SCBD) Lot 28, Senopati Raya <br>
                                                Jl. Jenderal Sudirman Kav.52 – 53, Jakarta 12190, INDONESIA <br>
                                                Telp. (021) 29333151 (hunting), 72795445, Fax. (021) 29333154-55, 72795441/49 <br>
                                                Website: www.iapi.or.id Email: info@iapi.or.id
                                            </p>
                                        </div>
                                    </center>
                            </div>
                        </div>
                    </section>
                    <!-- End Card 1 Back -->
                </div>
            </div>
        </section>
    </vue-html2pdf>
</div>
</template>
<script type="text/javascript" src="/js/jquery-flip.js"></script>

<script>
import KartuAnggotaService from '@/services/web-view/kartu-anggota.service'
export default {
    data() {
        return {
            items: [],
            status: 'front',
            frontActive: true,
            backActive: false,
            noAnggota: '',
            lihat_foto : null,
            output_front: null,
            output_back: null,
        }
    },
    mounted() {
        this.getData();

    },
    methods: {
        
        async exportImage() {
            let loader = this.$loading.show({
                    // Optional parameters
                    container: this.fullPage ? null : this.$refs.formContainer,
                    canCancel: true,
                    onCancel: this.onCancel,
                });
                // simulate AJAX
                setTimeout(() => {
                    loader.hide()
                    function dataURLtoFile(dataurl, filename) {
                        var arr = dataurl.split(','),
                            mime = arr[0].match(/:(.*?);/)[1],
                            bstr = atob(arr[1]), 
                            n = bstr.length, 
                            u8arr = new Uint8Array(n);
                            
                        while(n--){
                            u8arr[n] = bstr.charCodeAt(n);
                        }
                        
                        return new File([u8arr], filename, {type:mime});
                    }
                }, 1000)

            const el_front = this.$refs.printFront;
            const el_back = this.$refs.printBack;
            // add option type to get the image version
            // if not provided the promise will return 
            // the canvas.
            const options = {
                type: 'dataURL',
                scale: 2,
                dpi: 600,
                factor: 0.5,
                canvas: null,
                allowTaint: true,
                letterRendering: true,
                onrendered: function(canvas) {
                    theCanvas = canvas;
                    document.body.appendChild(canvas);
                   
                    // Convert and download as image 
                    Canvas2Image.saveAsPNG(canvas); 
                    $("#img-out").append(canvas);
                    // Clean up 
                    //document.body.removeChild(canvas);
                    var ctx = canvas.getContext('2d');
                    ctx.webkitImageSmoothingEnabled = false;
                    ctx.mozImageSmoothingEnabled = false;
                    ctx.imageSmoothingEnabled = false;
                }
            }
            var output_front = await this.$html2canvas(el_front, options);
            // // comment console console.log("BASE 64"+output_front)
            // alert(output_front);
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";

            var url = output_front;
            var noAnggota = this.noAnggota;
            a.href = url;
            a.download = `kartu-anggota-biasa-front-` + noAnggota + `.png`;
            a.click();
            var output_back = await this.$html2canvas(el_back, options);

            var ab = document.createElement("a");
            ab.setAttribute('id','output_back_a')
            document.body.appendChild(ab);

            ab.style = "display: none";
            var urlb = output_back 
            ab.href = urlb;
            ab.download = `kartu-anggota-biasa-back-` + noAnggota + `.png`;
            ab.click();

        },
        imgError(e) {
            e.target.src = '/img/placeholder-image.png'
        },
        generateReport () {
            this.$refs.html2Pdf.generatePdf()
        },
        createQr() {
            new QRCode(document.getElementById("card-qrcode2"), {
                text: "https://validasi.iapi.or.id/verifikasi/biasa/"+this.noAnggota,
               
                colorDark : "#000000",
                colorLight : "#ffffff",
                correctLevel : QRCode.CorrectLevel.H
            });
             new QRCode(document.getElementById("card-qrcode"), {
                text: "https://validasi.iapi.or.id/verifikasi/biasa/"+this.noAnggota,
               
                colorDark : "#000000",
                colorLight : "#ffffff",
                correctLevel : QRCode.CorrectLevel.H
            });
        },
        flipToFront() {
            this.createQr()
            this.status = 'front';
            this.frontActive = true;
            this.backActive = false;
        },
        flipToBack() {

            this.status = 'back';
            this.backActive = true;
            this.frontActive = false;
        },
        
        getData() {
            let loader = this.$loading.show({
                container: false ? null : this.$refs.formContainer,
                canCancel: true,
                onCancel: this.onCancel
            });
            KartuAnggotaService.getDataKartu(this.$route.params.id_user)
            .then(response => {
                this.noAnggota = response.data.singleData.noAnggota;
                this.items = response.data.singleData;
                let routeData = "https://member.iapi.or.id/img_profile/" + response.data.singleData.imgProfile;
                this.lihat_foto = routeData;
                this.createQr()
                loader.hide();

            }).catch(error => {
                loader.hide();
            });
        }
    }
}
</script>
